// SmartCHG API configuration.
//
// The frontend always calls the backend via an absolute URL baked in at build
// time via VITE_API_BASE_URL. There is no same-origin fallback and no
// Vite proxy; axios and fetchEventSource prepend this URL to every request.

const DEFAULT_BACKEND_URL = '';

/**
 * Resolve the backend base URL.
 * - If VITE_API_BASE_URL is defined in the Vite env (even as empty),
 *   use it. Empty string = same-origin (only meaningful when the bundle is
 *   served from the same host the API lives on).
 * - Otherwise default to same-origin so Istio/ingress can split frontend
 *   and backend traffic without a separate frontend build per environment.
 */
const getBackendBaseUrl = (): string => {
  const envUrl = import.meta.env.VITE_API_BASE_URL;
  if (typeof envUrl === 'string') {
    console.info('[API Config] VITE_API_BASE_URL =', envUrl || '(same-origin)');
    return envUrl;
  }
  console.info('[API Config] VITE_API_BASE_URL unset — defaulting to same-origin');
  return DEFAULT_BACKEND_URL;
};

export const API_CONFIG = {
  // Absolute backend URL — prepended to every /api/* and /auth/* request.
  BACKEND_BASE_URL: getBackendBaseUrl(),

  MAX_RETRIES: parseInt(import.meta.env.VITE_MAX_RETRIES || '3'),
  RETRY_DELAY: parseInt(import.meta.env.VITE_RETRY_DELAY || '1000'),

  IS_PRODUCTION: import.meta.env.PROD,
};

/**
 * Return the active API configuration and log it once.
 */
export const getApiConfig = () => {
  const config = { ...API_CONFIG };
  console.group('[API Configuration]');
  console.log('Mode:', import.meta.env.MODE);
  console.log('Backend Base URL:', config.BACKEND_BASE_URL || '(same-origin)');
  console.log('Max Retries:', config.MAX_RETRIES);
  console.log('Retry Delay:', config.RETRY_DELAY + 'ms');
  console.groupEnd();
  return config;
};
